import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import jsPDF from 'jspdf';
import * as moment from 'moment';
@Component({
  selector: 'app-simulador-liquido-previdencia',
  templateUrl: './simulador-liquido-previdencia.component.html',
  styleUrls: ['./simulador-liquido-previdencia.component.css']
})
export class SimuladorLiquidoPrevidenciaComponent {
  @ViewChild('contentPrint', { static: false }) el!: ElementRef;
  @Input() simulacao: any;
  simulation: any;
  date: any;
  constructor(public activeModal: NgbActiveModal) {
    this.simulation = this.simulacao;
    moment.locale('pt-br');
    this.date = moment().format("DD/MM/YYYY") + ' ' + moment().format('LT');
    setTimeout(() => {
      const pdf = new jsPDF('p', 'pt', 'letter');
      pdf.getFontList()
      pdf.html(this.el.nativeElement, {
        margin: [20, 10, 10, 10],
        callback: (pdf: any) => {
          pdf.setLineWidth(pdf.internal.pageSize.getWidth())
          pdf.save('Simulador Previdencia.pdf');
          this.activeModal.close(true);
        }
      })
    }, 1);
  }
}
